export const AUTHENTICATE = 'Auth/AUTHENTICATE';
export const CLEAN_AUTHENTICATION = 'Auth/CLEAN_AUTHENTICATION';
export const DELETE_AUTH_USER = 'Auth/DELETE_AUTH_USER';
export const FORGOT_PASSWORD = 'Auth/FORGOT_PASSWORD';
export const GET_AUTH_USER = 'Auth/GET_AUTH_USER';
export const RESET_PASSWORD = 'Auth/RESET_PASSWORD';
export const SETUP_AUTHENTICATION = 'Auth/SETUP_AUTHENTICATION';
export const UNAUTHENTICATE = 'Auth/UNAUTHENTICATE';
export const UPDATE_AUTH_USER = 'Auth/UPDATE_AUTH_USER';
